"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/components/ContextualMenu");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var owa_mail_search_actions_1 = require("owa-mail-search-actions");
var owa_mail_search_store_1 = require("owa-mail-search-store");
var Store_1 = require("owa-mail-store/lib/store/Store");
var searchViewConstants_1 = require("../utils/searchViewConstants");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var React = require("react");
var styles = require('./FiltersContextMenu.scss');
var FiltersContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(FiltersContextMenu, _super);
    function FiltersContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismiss = function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.stopPropagation();
                        return [4 /*yield*/, owa_mail_search_store_1.lazySetShowFiltersMenu.importAndExecute(false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Handle change in folder scope from the filter context menu
         */
        _this.changeFolderScope = function (evt, newFolderId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // set the new folder scope
                    return [4 /*yield*/, owa_mail_search_actions_1.lazyChangeFolderScope(newFolderId)];
                    case 1:
                        // set the new folder scope
                        _a.sent();
                        this.props.onFolderScopeChanged();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    FiltersContextMenu.prototype.render = function () {
        return (React.createElement(ContextualMenu_1.ContextualMenu, { shouldFocusOnMount: true, target: this.props.targetElement, className: styles.filtersContextMenu, directionalHintFixed: true, gapSpace: 2, onDismiss: this.onDismiss, directionalHint: 6 /* bottomRightEdge */, items: this.searchMenuItems }));
    };
    Object.defineProperty(FiltersContextMenu.prototype, "searchMenuItems", {
        get: function () {
            var _this = this;
            var msgFolderRootId = folderNameToId_1.default('msgfolderroot');
            // Add some distinguished folders and a root folder
            var folderIds = [
                msgFolderRootId,
                folderNameToId_1.default('inbox'),
                folderNameToId_1.default('deleteditems'),
                folderNameToId_1.default('sentitems'),
            ];
            // Add the archive folder if user has one set
            var archiveFolderId = getUserConfiguration_1.default().UserOptions.ArchiveFolderId;
            if (archiveFolderId) {
                folderIds.push(archiveFolderId);
            }
            // Add the current folder scope if not there already (Inbox for e.g. will be pre-popualated above)
            var currentFolderScopeId = owa_mail_search_store_1.searchStore.staticFolderScopeId;
            if (folderIds.indexOf(currentFolderScopeId) == -1) {
                folderIds.push(currentFolderScopeId);
            }
            // Create the filter context menus
            var items = [];
            var _loop_1 = function (i) {
                var folderId = folderIds[i];
                var displayName = folderId == msgFolderRootId
                    ? owa_mail_strings_1.default.allFolders
                    : Store_1.default.folders.folderTable.get(folderId).DisplayName;
                items.push({
                    key: folderId,
                    name: displayName,
                    canCheck: true,
                    isChecked: folderId == owa_mail_search_store_1.searchStore.staticFolderScopeId,
                    onRender: function () { return (React.createElement("div", { "data-is-focusable": true, className: styles.filterMenuItem, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, onClick: function (evt) { return _this.changeFolderScope(evt, folderId); } },
                        React.createElement("div", { className: styles.checkMarkContainer }, folderId == owa_mail_search_store_1.searchStore.staticFolderScopeId && (React.createElement(Icon_1.Icon, { iconName: "CheckMark" /* CheckMark */ }))),
                        React.createElement("div", { className: styles.folderName }, displayName))); },
                });
            };
            for (var i = 0; i < folderIds.length; i++) {
                _loop_1(i);
            }
            return items;
        },
        enumerable: true,
        configurable: true
    });
    FiltersContextMenu = tslib_1.__decorate([
        mobx_react_1.observer
    ], FiltersContextMenu);
    return FiltersContextMenu;
}(React.Component));
exports.default = FiltersContextMenu;
//# sourceMappingURL=FiltersContextMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-search-view/lib/components/FiltersContextMenu.js
// module id = 4831
// module chunks = 37